// extracted by mini-css-extract-plugin
export default {"modal":"basic_modal__7fh4r","title":"basic_title__jcmci","content":"basic_content__D5a8K"};